import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Prevision } from '../models/prevision.entity';

const BASE_URL = 'previsions';

@Injectable({
  providedIn: 'root',
})
export class PrevisionsService {
  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   */

  constructor(private apiService: ApiService) {
    this.loading$ = this.apiService.loading$;
  }

  /**
   * Get
   *
   * @param id Id of prevision
   */
  get(id: number): Observable<Prevision> {
    return this.apiService.get(`${BASE_URL}/${id}`).pipe(map((prevision: Prevision) => Prevision.create(prevision)));
  }

  /**
   * List previsions
   */
  list(): Observable<Prevision[]> {
    return this.apiService.post(BASE_URL, { order: 'STTRG' }).pipe(map(previsions => previsions.map(prevision => Prevision.create(prevision))));
  }

  /**
   * Create
   *
   * @param prevision Prevision instance
   */
  create(prevision: Prevision): Observable<any> {
    return this.apiService.post(BASE_URL, prevision);
  }

  /**
   * Update
   * @param previsionId Prevision id
   * @param prevision Prevision instance
   */
  update(previsionId: string, prevision: Prevision): Observable<any> {
    prevision.ZZMOVIL = prevision.ZZMOVIL.toString();
    return this.apiService.patch(`${BASE_URL}/${previsionId}`, prevision);
  }

  /**
   * Delete
   *
   * @param previsionId Primary key
   */
  delete(previsionId: string): Observable<any> {
    return this.apiService.delete(`${BASE_URL}/${previsionId}`);
  }

  /**
   * Find filtered
   *
   * @param queryOptions Object with query options
   */
  findFiltered(queryOptions): Observable<Prevision[]> {
    return this.apiService.post(`${BASE_URL}/list`, queryOptions).pipe(map(previsions => previsions.map(prevision => Prevision.create(prevision))));
  }

  /**
   * Get count for filter
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Filter object
   */
  // tslint:disable-next-line:max-line-length
  getCount(order: string = 'TKNUM', sort: string = 'desc', limit: number = 30, page: number = 0, filter: object = {}): Observable<object> {
    const options = { order, sort, limit, page };
    for (const i in filter) {
      if (filter.hasOwnProperty(i) && filter[i] === '') {
        delete filter[i];
      }
    }
    return this.apiService.post(`${BASE_URL}/count`, { ...options, ...filter });
  }
}
